import { COLOR_PALETTE } from "colors"

export const COLORS: string[] = [
	COLOR_PALETTE.PURPLE_500,
	COLOR_PALETTE.YELLOW_600,
]

export const getMaxValue = (data: Array<any>, keys: string[]): number => {
	let maxValue = 0
	data.forEach((obj) => {
		maxValue = keys.reduce((prev, curr) => Math.max(prev, obj[curr]), maxValue)
	})
	return maxValue
}
